'use client'

import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import styled from 'styled-components'
import breakpoints from '@/utils/breakpoints'
import { SpinBTProps } from './button'

const catchWidth = `${breakpoints('width', '', [
  { 1200: '450px' },
  { 800: '450px' },
])}`

export const SpinButton = styled.div<SpinBTProps>`
  ${({
    theme: {
      base: { grey },
    },
    disabled,
    gap = '2rem',
  }: any) => `
    ${catchWidth};
    display: flex;
    cursor: pointer;
    position: relative;
    text-transform: uppercase;
    align-items: center;
    justify-content: center;
    background-color: ${!!disabled ? grey[10] : '#000000'};
    margin: 0 auto ${gap};
    width: 100%;
    height: 50px;
    color: #F8F8F8;
    transition: background-color 0.2s ease-in-out;
    ${!!disabled && `pointer-events: none;`}

    &:hover {
      background-color: ${!!disabled ? grey[10] : '#484848'};
    }

    &:active {
      background-color: #C0C0C0;
    }
  `}
`

export const SpinButtonWithoutBreakpoint = styled.div<SpinBTProps>`
  ${({ disabled, gap = '2rem', labelTransform = 'uppercase' }: any) => `
    display: flex;
    cursor: pointer;
    position: relative;
    text-transform: ${labelTransform};
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${!!disabled ? '#C0C0C0' : '#000000'};
    margin: 0 auto ${gap};
    width: 100%;
    height: 50px;
    color: #F8F8F8;
    transition: background-color 0.2s ease-in-out;
    border: unset;
    user-select: none;
    ${!!disabled && `pointer-events: none;`}

    &:hover {
      background-color: ${!!disabled ? '#C0C0C0' : '#484848'};
    }

    &:active {
      background-color: #C0C0C0;
    }
  `}
`

export const SpinButtonOutlintBreakpoint = styled(
  SpinButtonWithoutBreakpoint
)<SpinBTProps>`
  ${({
    theme: {
      base: {
        shade: { white },
      },
    },
    bold,
    color = null,
    active,
    activebg,
  }: any) => `
    background-color: ${activebg ? white[0] : 'transparent'};
    color: ${color || '#000000'};
    border: 2px solid ${color || '#000000'};
    ${bold ? `font-weight: 700;` : ''}

    &:hover {
      background-color: ${activebg ? white[0] : '#000000'};
      color: ${color || white[0]};
    }

    ${
      active
        ? `
      background-color: ${'#000000'};
      color: ${color || white[0]};
    `
        : ''
    }
  `}
`

export const ButtonOutLineBreakpoint = styled.div<SpinBTProps>`
  ${({
    theme: {
      base: {
        shade: { blue },
      },
    },
    disabled,
    gap = '2rem',
  }: any) => `
    display: flex;
    cursor: pointer;
    user-select: none;
    position: relative;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    margin: 0 auto ${gap};
    width: fit-content;
    padding: 0 1rem;
    color: ${'#000000'};
    transition: background-color 0.2s ease-in-out;
    border: unset;
    ${!!disabled ? `pointer-events: none;` : ''}
    transition: all 0.2s ease-in-out;
    &:hover {
      color: ${blue[1]};
    }
  `}
`

